import { Link } from "react-router-dom";
import { Package } from "lucide-react";

export const Header = () => {
  return (
    <header
      className="w-full border-b border-slate-200 bg-white/80 backdrop-blur"
      data-testid="app-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
        <Link
          to="/"
          className="flex items-center gap-3"
          data-testid="header-logo-link"
        >
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-100 text-indigo-600">
            <Package size={20} strokeWidth={2} />
          </div>
          <div className="leading-tight">
            <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-400">
              Mail Boxes Etc
            </div>
            <div className="text-base font-bold tracking-tight text-slate-900">
              Palettenversand verfolgen
            </div>
          </div>
        </Link>
        <nav className="hidden items-center gap-8 md:flex">
          <Link
            to="/"
            className="text-sm font-medium text-slate-500 transition-colors hover:text-slate-900"
            data-testid="header-home-link"
          >
            Tracking
          </Link>
        </nav>
      </div>
    </header>
  );
};
